import { Star } from 'lucide-react';

// Permanent badge for the ~30 beta testers flagged founding_member. Rendered
// wherever we show who the user is, so it's a standing thank-you rather than a
// one-off message they dismiss and never see again.
//
// `size`: 'sm' for tight spots (sidebar), 'md' for headers.
// `onDark`: use on the dashboard's dark green header.
const FoundingBadge = ({ size = 'sm', onDark = false, className = '' }) => {
    const sm = size === 'sm';
    return (
        <span
            title="Founding member — thank you for helping build Mimique"
            className={`inline-flex items-center gap-1 rounded-full font-semibold whitespace-nowrap ${
                sm ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs'
            } ${
                onDark
                    // Neutral pill on dark so only the star carries the gold —
                    // a fully amber badge reads as a warning against the green.
                    ? 'bg-white/10 text-white/90 ring-1 ring-inset ring-white/20'
                    : 'bg-amber-100 text-amber-800 ring-1 ring-inset ring-amber-300'
            } ${className}`}
        >
            {/* Gold star in both variants — it's the bit that reads as "special" */}
            <Star
                className={`${sm ? 'h-2.5 w-2.5' : 'h-3 w-3'} fill-current ${onDark ? 'text-amber-400' : 'text-amber-500'}`}
            />
            Founding Member
        </span>
    );
};

export default FoundingBadge;
